import { Box, TextInputNew } from '@jfs/ui-new'

export const FilterTextFields = (
  themedStyle,
  error,
  selectedFilteredData,
  filtersStrings,
  handleFilter,
  otherFilters,
  type,
  testId,
  style,
) => {
  return (
    <Box {...[themedStyle.childContainer, themedStyle.bottomFix]}>
      <TextInputNew
        {...themedStyle[style]}
        error={error}
        touched={true}
        value={selectedFilteredData?.[type] ?? filtersStrings.empty}
        placeholder={filtersStrings[type]}
        label={filtersStrings[type]}
        testID={testId}
        onChangeText={(value) => handleFilter(value, otherFilters[type])}
      />
    </Box>
  )
}
